import ResetPasswordForm from "../../forms/ResetPasswordForm";

export default function ResetPassword() {
  return <ResetPasswordForm />;
}
